import React, { useState } from 'react';
import { AppBar, Toolbar, Box, Button, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText, useScrollTrigger } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import logoImg from '../../assets/logo/Logo.webp';

const NAV_LINKS = [
  { label: 'Servicios', href: '#services' },
  { label: 'Galería', href: '#gallery' },
  { label: 'Eventos', href: '#events' },
  { label: 'FAQ', href: '#faq' },
];

interface Props {
  onOpenContact: () => void;
}

const Header: React.FC<Props> = ({ onOpenContact }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: 40 });

  return (
    <>
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          background: scrolled ? 'rgba(13,13,13,0.95)' : 'transparent',
          backdropFilter: scrolled ? 'blur(8px)' : 'none',
          transition: 'background 0.3s',
          borderBottom: scrolled ? '1px solid #2a2a2a' : 'none',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', maxWidth: 'var(--container-max)', width: '100%', mx: 'auto', px: { xs: 2, md: 4 } }}>
          {/* Logo */}
          <Box
            component="a"
            href="#"
            sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
          >
            <Box
              sx={{
                bgcolor: 'transparent',
                borderRadius: '6px',
                px: 1,
                py: 0.5,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box
                component="img"
                src={logoImg}
                alt="Sushigi Catering"
                sx={{ height: { xs: 48, md: 60 }, display: 'block' }}
              />
            </Box>
          </Box>

          {/* Desktop nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3, alignItems: 'center' }}>
            {NAV_LINKS.map((link) => (
              <Box
                key={link.label}
                component="a"
                href={link.href}
                sx={{ color: 'var(--color-text-secondary)', textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '0.05em', '&:hover': { color: 'var(--color-accent)' }, transition: 'color 0.2s' }}
              >
                {link.label}
              </Box>
            ))}
            <Button
              variant="contained"
              onClick={onOpenContact}
              sx={{ bgcolor: 'var(--color-accent)', color: '#0d0d0d', fontWeight: 700, px: 3, '&:hover': { bgcolor: 'var(--color-accent-hover)' } }}
            >
              Contacto
            </Button>
          </Box>

          {/* Mobile hamburger */}
          <IconButton
            sx={{ display: { xs: 'flex', md: 'none' }, color: 'var(--color-text-primary)' }}
            onClick={() => setDrawerOpen(true)}
            aria-label="Abrir menú de navegación"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile drawer */}
      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)} slotProps={{ paper: { sx: { bgcolor: '#0d0d0d', width: 260 } } }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <IconButton onClick={() => setDrawerOpen(false)} sx={{ color: 'var(--color-text-primary)' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <List>
          {NAV_LINKS.map((link) => (
            <ListItem key={link.label} disablePadding>
              <ListItemButton component="a" href={link.href} onClick={() => setDrawerOpen(false)}>
                <ListItemText primary={link.label} slotProps={{ primary: { sx: { color: 'var(--color-text-primary)', fontSize: '1.1rem' } } }} />
              </ListItemButton>
            </ListItem>
          ))}
          <ListItem sx={{ mt: 2, px: 2 }}>
            <Button
              fullWidth
              variant="contained"
              onClick={() => { setDrawerOpen(false); onOpenContact(); }}
              sx={{ bgcolor: 'var(--color-accent)', color: '#0d0d0d', fontWeight: 700 }}
            >
              Contacto
            </Button>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default Header;
